import script from "./app.vue?vue&type=script&setup=true&lang=ts"
export * from "./app.vue?vue&type=script&setup=true&lang=ts"

import "./app.less?vue&type=style&index=0&lang=less&external"

const __exports__ = script;

export default __exports__